<script>
  import "./projectTransactionTab.css";
  import { getSaleTransactionMetaService } from "../../../../../services/saleTransactionApi";
  import dayjs from "dayjs";
  import {
    BLOCK_EXPLORER,
    transactionType,
  } from "../../../../constants/constants";
  import {
    addEllipses,
    formatScientificNumber,
    formatNumber,
    formateToPrecision,
  } from "../../../../utils";
  import { signer, signerAddress } from "svelte-ethers-store";
  import { getContext } from "svelte";
  import { tokenPurchased } from "../../../../store";

  import RefundModel from "./refund-model/RefundModel.svelte";

  export let saleContract, currentStep;
  let transactions = [];
  let fetchingTransactions = false;

  const { open } = getContext("simple-modal");

  $: !$signerAddress && (currentStep = 1);

  let status;

  const fetchTransactions = async () => {
    fetchingTransactions = !fetchingTransactions;
    const transactionResp = await getSaleTransactionMetaService(
      saleContract?.address ?? "",
      $signerAddress
    );
    transactions = transactionResp.data.saleTransactions;
    let sum = 0;
    transactions.forEach((transaction) => {
      sum +=
        transaction.__typename === transactionType.Buy
          ? formatNumber(
              transaction.receipt.units,
              transaction.saleContract.token.decimals
            )
          : -formatNumber(
              transaction.receipt.units,
              transaction.saleContract.token.decimals
            );
    });
    tokenPurchased.set(sum);
    setTimeout(() => {
      fetchingTransactions = !fetchingTransactions;
    }, 800);
  };

  $: if ($signer && saleContract) {
    (async () => {
      status = await saleContract.saleStatus();
      fetchTransactions();
    })();
  }
</script>

<div class="transaction-tab relative">
  <div class="transition-table">
    {#if transactions.length === 0}
      <p class="text-center">No Transactions History</p>
    {:else if transactions && $signerAddress}
      <table id="transaction">
        <tr>
          <th>Type</th>
          <th>Date</th>
          <th>My Transactions</th>
          <th>Token Quantity</th>
          <th>Token Value</th>
          <th />
        </tr>
        {#each transactions as transaction}
          <tr>
            <td>
              {transaction.__typename === transactionType.Buy
                ? "Buy"
                : "Refund"}
            </td>
            <td>{dayjs.unix(transaction.timestamp).format("DD-MM-YYYY")}</td>
            <td>
              <a
                href={`${BLOCK_EXPLORER}/tx/${transaction.transactionHash}`}
                target="_blank"
              >
                {addEllipses(transaction.transactionHash)}
              </a>
            </td>
            <td>
              {formatScientificNumber(
                formatNumber(
                  transaction.receipt.units,
                  transaction.saleContract.token.decimals
                )
              )}
            </td>
            <td>
              {formateToPrecision(
                formatNumber(
                  transaction.receipt.price,
                  transaction.saleContract.reserve.decimals
                ) *
                  formatNumber(
                    transaction.receipt.units,
                    transaction.saleContract.token.decimals
                  )
              )}
              {transaction.saleContract.reserve.symbol}
            </td>
            <td>
              {#if transaction.__typename === "SaleBuy" && !transaction.refunded && (status == 3 || status === 1)}
                <span
                  class="refund-btn"
                  on:click={() => {
                    open(RefundModel, {
                      saleContract,
                      token: transaction.saleContract.token,
                      reserve: transaction.saleContract.reserve,
                      transaction,
                      sale: transaction.saleContract,
                    });
                  }}
                >
                  Refund
                </span>
              {:else if transaction.refunded}
                <span class="refund-btn refunded">Refunded</span>
              {/if}
            </td>
          </tr>
        {/each}
      </table>
    {/if}
  </div>
  <div class="refresh-icon" on:click={() => fetchTransactions()}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      color="#E426B2"
      class={fetchingTransactions ? "rotate" : ""}
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path
        d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
      />
    </svg>
  </div>
</div>
